import { Avatar } from '@app/components/common/Avatar/Avatar';
import { Button } from '@app/components/common/buttons/Button/Button';
import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Col, Collapse, Row } from 'antd';
import styled from 'styled-components';

export const Header = styled.header<{ scrolled: boolean }>`
  background-color: #ffffff;
  color: #37352f;
  padding: 17.5px 72px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
  position: ${({ scrolled }) => (scrolled ? 'fixed' : 'relative')};

  .app-logo {
    width: 177px;
    height: 71px;
  }

  .m-0 {
    margin: 0;
  }

  h2 {
    margin: 0;
    color: #37352f;
    font-weight: ${FONT_WEIGHT.medium};
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: start;
    line-height: normal;
  }

  .title {
    margin: 0;
    color: #37352f;
    font-weight: ${FONT_WEIGHT.medium};
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: start;
    line-height: normal;
  }

  nav {
    display: flex;
    justify-content: center;
    position: relative;
    gap: 8px;

    .ant-avatar-group {
      align-items: center;
      .avatar-wrapper {
        margin-top: 0;
      }
    }
  }

  .language-selector {
    .language-name {
      margin-inline-end: 5px;
    }
  }

  @media screen and (max-width: 1025px) {
    position: ${({ scrolled }) => (scrolled ? 'fixed' : 'relative')};
    padding: 15px;
    box-shadow: ${({ scrolled }) => (scrolled ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none')};
  }

  @media screen and (max-width: 768px) {
    position: ${({ scrolled }) => (scrolled ? 'fixed' : 'relative')};
    padding: 15px;
    box-shadow: ${({ scrolled }) => (scrolled ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none')};

    .ant-avatar-image {
      min-width: 40px;
      min-height: 40px;
      max-width: 40px;
      max-height: 40px;
      line-height: 40px;
    }

    .language-selector {
      .language-name {
        display: none;
      }
    }

    .title {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 22px;
      font-weight: ${FONT_WEIGHT.extremeBold};
    }
  }

  @media screen and (max-width: 768px) {
    padding: 15px 15px;
  }

  @media screen and (max-width: 620px) {
    padding: 15px 12px;
  }
`;

export const DealRoomStatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.medium};
`;

export const PageBanner = styled.div<{ scrolled: boolean }>`
  background-color: transparent;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100vh;
  max-height: 430px;
  padding: 40px 40px 0;
  display: flex;
  justify-content: center;

  .hero-content {
    background-color: #fff;
    padding: 20px;
    text-align: center;
    border-radius: 0;
    background-position: center center;
    background-size: 100%;
    background-repeat: no-repeat;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: calc(100% - 160px);
    border-radius: 8px;
    border: 1px solid #e9e9e7;
  }

  .icons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5em;

    img {
      width: 130px;
      height: 130px;
      margin: 0 10px;
      object-fit: cover;
      border-radius: 50%;
      border: 1px solid #e9e9e7;

      @media screen and (max-width: 768px) {
        width: 65px;
        height: 65px;
      }
    }
  }

  @media screen and (max-width: 1025px) {
    height: 100%;
    padding: 20px 20px 0px;
    padding-top: ${({ scrolled }) => (scrolled ? '20px' : '20px')};

    .hero-content {
      max-width: 100%;
      padding: 30px 20px;
    }
  }

  @media screen and (max-width: 768px) {
    height: 100%;
    padding: 20px 8px 0px;
    padding-top: ${({ scrolled }) => (scrolled ? '20px' : '20px')};

    .hero-content {
      max-width: 100%;
      padding: 30px 20px;
    }
  }
`;

export const PageBannerImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;
  object-position: center;
`;

export const ShareButton = styled.button`
  background-color: transparent !important;
  border: none;
  padding: 0 !important;
  cursor: pointer !important;
  font-size: 22px;
  font-weight: ${FONT_WEIGHT.medium};
  display: flex;
  align-items: center;

  &:after {
    display: block;
    content: '';
    width: 2px;
    height: 80%;
    background-color: #eaecee;
    margin-inline: 10px 4px;
  }
`;

export const MouseflowButton = styled.button<{ $levelColor?: string; $disabled?: boolean }>`
  position: relative;
  background-color: transparent;
  border: none;
  padding: 4px 6px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-size: 22px;
  color: ${({ $disabled }) => ($disabled ? '#a0a09d' : '#1a295a')};
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  transition: background 0.15s;

  &::after {
    display: block;
    content: '';
    width: 2px;
    height: 80%;
    background-color: #eaecee;
    margin-inline: 10px 4px;
  }

  .mf-level-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ $levelColor }) => $levelColor || '#9e9e9e'};
    box-shadow: 0 0 0 2px #fff;
  }

  .mf-level-text {
    font-size: 14px;
    font-weight: ${FONT_WEIGHT.medium};
    color: ${({ $levelColor }) => $levelColor || '#9e9e9e'};
  }
`;

export const BlueButton = styled.button`
  background-color: #1a295a;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  height: 36px;
  min-width: 135px;
  padding: 0 16px;
  margin-block: auto;
  font-weight: ${FONT_WEIGHT.medium};

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Main = styled.main`
  // background-color: #ffffff;
  background-color: #f4f8fb;
  padding: 40px 40px 80px;
  min-height: 100vh;

  @media screen and (max-width: 768px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
    padding: 20px 8px 20px;
  }

  section {
    margin: 40px 80px;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #e9e9e7;

    &.no-margin {
      margin: 0 !important;
      align-self: stretch;
    }

    .chatApp__conv {
      margin: 0;
    }

    @media screen and (max-width: 768px) {
      margin: 0 20px;
    }

    @media (max-width: 576px) {
      margin: 0 0;
    }

    &:first-child {
      margin-top: 90px;
    }
  }

  p {
    margin: 0;
  }

  .hero {
    .hero-content {
      background-color: #f0e8d4;
      padding: 20px;
      text-align: center;
      border-radius: 10px;
      background-position: center center;
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }

  .drag-drop {
    padding: 15px;

    .ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
      color: #1cccb2;
    }

    .ant-upload-list.ant-upload-list-text {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 0;
      align-items: center;
      justify-content: flex-start;
      padding: 15px;
      margin: 0;
    }

    .ant-upload-list::after,
    .ant-upload-list::before {
      display: none;
    }

    .ant-upload-text {
      color: rgba(0, 0, 0, 0.45) !important;
    }

    .ant-upload-list-text-container {
      padding: 0;
    }

    .ant-upload-list-item {
      margin: 0;
      height: auto;
      max-height: max-content;
    }

    .ant-upload-list-item-info {
      color: #404040;
      padding: 10px 5px;
      border: 1px solid transparent;
    }

    .ant-upload-list-item:hover .ant-upload-list-item-info {
      cursor: pointer;
      color: #404040;
      background: #f5f5f5;
      border-color: #f5f5f5;
    }

    @media screen and (max-width: 768px) {
      padding-bottom: 20px;
      section.drag-drop {
        margin: 0;
      }

      .ant-upload-list.ant-upload-list-text {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 5px 0;
      }

      .ant-upload-list-text-container {
        padding: 0 15px;
        width: 100%;
      }

      span.ant-upload-list-item-name {
        white-space: break-spaces;
        max-width: 100%;
        display: inline-block;
        word-break: break-all;
      }

      .ant-upload-list-picture-container::before,
      .ant-upload-list-text-container::before {
        display: none;
      }

      .ant-upload-list-item-info {
        width: 100%;
        padding: 0;
      }
    }
  }

  .icons {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5em;

    img {
      width: 50px;
      height: 50px;
      margin: 0 10px;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .info {
    padding: 20px;

    .info-text {
      text-align: center;
      color: black;
    }
  }

  .contact-info {
    padding: 20px;
    max-width: max-content;
    min-width: 350px;
    margin-inline: auto;

    @media screen and (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }

  .ant-upload.ant-upload-drag {
    border: 2px dashed #e9e9e7;
    padding: 20px;
    text-align: center;
    background-color: #fff;

    &:hover {
      border-color: #1cccb2;
    }
  }

  .downloads {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px;
    flex-wrap: wrap;

    @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }

  .download-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    .icon {
      .file-icon {
        width: 80px;
        height: 100px;
        background-color: var(--primary-color);
        border: 2px solid var(--primary-color);
        border-radius: 4px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: ${FONT_WEIGHT.extremeBold};
        color: white;
        font-size: 18px;
        text-transform: uppercase;
      }

      .file-icon::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        background-color: white;
        clip-path: polygon(0 0, 100% 0, 100% 100%);
      }

      .extension {
        z-index: 1;
      }
    }
  }
`;

export const FileTableWrapper = styled.div`
  overflow-x: auto;
  display: block;
  width: 100%;
`;

export const FileTable = styled.table`
  width: 100%;
  border: 1px solid #ddd;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  padding: 0;

  a {
    color: #1cccb2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  thead {
    background-color: rgb(247, 247, 248);
    color: #37352f;
    th {
      padding: 10px;
    }
  }

  .text-center {
    text-align: center;
  }

  td,
  th {
    border: 1px solid #ddd;
    padding-block: 4px;
    padding-inline: 8px;
    text-align: start;
    color: black;
  }

  .deal-ltr {
    direction: ltr;
  }

  @media screen and (max-width: 768px) {
    .hide-mobile {
      display: none;
    }

    .column-file-name {
      max-width: 200px;
      word-wrap: break-word;
    }
  }
`;

export const DownloadColumn = styled.td`
  width: 80px;
  text-align: center !important;
`;

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  color: #37352f;
  font-weight: ${FONT_WEIGHT.extremeBold};
  font-size: 14px;
  margin: 10px 0;
  .avatar-wrapper {
    margin-top: 0;
  }
`;

export const UserDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;

  .light-grey {
    color: #a0a09d;
    font-weight: ${FONT_WEIGHT.regular};
    font-size: 12px;
    margin: 0 !important;
  }

  .mb-0 {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: ${FONT_WEIGHT.extremeBold};
  color: #37352f;
  display: flex;
  width: 100%;
  justify-content: flex-start;
`;

export const DownloadButton = styled.button`
  color: #37352f;
  background: transparent;
  width: 30px;
  height: 30px;
  font-size: 14px;
  box-shadow: none;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    color: #1cccb2;
    border-color: #1cccb2;
  }
`;

export const TwoLayout = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  margin: 0 80px 40px;

  section {
    width: 50%;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 0;

    section {
      width: 100%;

      &.info {
        padding-inline: 0px;
        padding-bottom: 0;

        .info-text {
          padding-bottom: 20px;
          padding-inline: 20px;
        }

        .chat-room-title {
          padding-inline: 20px;
        }
      }

      .chatApp__convSendMessage {
        background: transparent;
      }

      &.chat-full-screen {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh;
        z-index: 998999;
        padding-inline: 0;
        overflow: hidden;

        .chatApp__convBox {
          position: fixed;
          bottom: 100px;
          left: 0;
          width: 100%;
          padding: 1rem;
          box-sizing: border-box;
          font-size: 16px;
          z-index: 9999;
        }

        .chat-room-wrapper,
        .chatApp__room {
          height: inherit;
          overflow: hidden;
          padding: 0;
        }

        .chat-room-title {
          padding-inline: 10px;
          .title {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .chatApp__convSendMessage {
          padding-inline: 5px;
        }

        .chatApp__convFileButton,
        .chatApp__convButton {
          padding: 20px;
        }

        .chatApp__convTimeline {
          min-height: calc(100vh - 85px);
          overflow-y: auto;
          padding-inline: 5px;
          padding-bottom: 160px;
        }
      }
    }
  }
`;

export const OnlineAvatar = styled(Avatar)`
  color: #fff;
  background-color: #007bff;
`;

export const ContactPersonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  color: #37352f;
  font-weight: ${FONT_WEIGHT.extremeBold};
  font-size: 14px;
  margin: 10px 0;

  .avatar-wrapper {
    margin-top: 0;
  }
`;

export const ContactPersonDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  .contact-icons {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: 12px;
    svg {
      font-size: 20px;
    }

    a {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #a0a09d;
    }
  }

  .cp-icon-wrapper {
    display: flex;
    gap: 7px;
    align-items: center;
    justify-content: start;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;

    .contact-icons {
      flex-wrap: wrap;
    }
  }
`;

export const FileCol = styled(Col)`
  display: flex;
  border-bottom: 1px solid #e9e9e7;
  margin-bottom: 15px;
  flex-direction: column;
  width: 100%;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img,
  .img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
  }
`;

export const Summary = styled.div`
  background-color: #f4f8fb;
  width: 100%;
  position: relative;
  padding: 40px 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    padding: 20px 8px 0;
    margin: 0;
    width: 100%;
  }
`;

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e9e9e7;
  width: 100%;
  max-width: calc(100% - 160px);

  @media screen and (max-width: 768px) {
    max-width: 100%;
    padding: 30px 20px;
  }
`;

export const SummaryTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: ${FONT_WEIGHT.extremeBold};
  color: #37352f;
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 0;
`;

export const SummaryNote = styled.p`
  font-size: 1rem;
  font-weight: ${FONT_WEIGHT.regular};
  color: #a0a09d;
  text-align: center;
  margin-bottom: 0;
`;

export const RowWrapper = styled(Row)`
  margin-top: 30px;
  display: flex;
  align-items: stretch;

  .ant-col.deal-room-counter {
    display: flex;
    max-width: 200px;
    flex: 0 0 16.66666667%;
    min-width: 16.66666667%;
  }

  &:first-child {
    margin-top: 0;
  }

  &:nth-child(2) {
    margin-top: 10px;
  }

  @media (max-width: 1200px) {
    .ant-col.deal-room-counter {
      flex: 0 0 33.33%;
      min-width: 33.33%;
    }
  }

  @media screen and (max-width: 768px) {
    margin-inline: 0 !important;
    column-gap: 10px !important;
    row-gap: 15px !important;

    .ant-col.deal-room-counter {
      display: flex;
      max-width: 200px;
      flex: 0 0 31%;
      min-width: 31%;
      min-height: 100px;
      max-height: 125px;

      .card-content {
        flex-direction: column-reverse;
        align-items: top;
        justify-content: flex-start;
        gap: 0px;
      }
    }
  }

  @media (max-width: 620px) {
    margin-inline: 0 !important;
    column-gap: 10px !important;
    row-gap: 15px !important;

    .ant-col.ant-col-md-6 {
      width: 100% !important;
      max-width: calc(50% - 5px) !important;
    }
  }
`;

export const ColumnWrapper = styled(Col)`
  svg {
    color: #1cccb2;
  }
  @media (max-width: 620px) {
    padding-inline: 0 !important;

    &.ant-col.ant-col-md-12 {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`;

export const FullScreenIcon = styled.span`
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  margin-inline-start: auto;
  padding: 5px;
  font-size: 18px;
  font-weight: ${FONT_WEIGHT.regular};
  border: none;
  box-shadow: none;
  transition: all 0.3s ease-in-out;
  color: grey;
  &:hover {
    color: #1cccb2;
  }

  @media screen and (max-width: 768px) {
    display: flex;
  }
`;

export const Body = styled.div<{ scrolled: boolean }>`
  display: flex;
  width: 100%;
  direction: rtl;
  padding: 54px 72px;
  padding-block-start: ${({ scrolled }) => (scrolled ? '150px' : '25px')};
  background: #f8f9fa;
  position: relative;

  @media screen and (max-width: 1441px) {
    padding: 40px 40px;
  }

  @media screen and (max-width: 1025px) {
    padding: 30px 40px;
    padding-block-start: ${({ scrolled }) => (scrolled ? '120px' : '30px')};
    flex-direction: column;
  }

  @media screen and (max-width: 768px) {
    padding: 15px;
    padding-block-start: 16px;
    flex-direction: column;
  }

  @media screen and (max-width: 568px) {
    padding: 24px 12px;
    padding-block-start: 32px;
    flex-direction: column;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SidebarWrapper = styled.div<{ scrolled: boolean }>`
  display: flex;
  align-items: ${({ scrolled }) => (scrolled ? 'flex-start' : 'flex-start')};
  justify-content: center;
  width: 100%;
  min-width: 350px;
  max-width: 30%;
  background-color: transparent;
  height: 78vh;
  min-height: max-content;
  border-right: none;
  padding: 0 0 0px 20px;
  padding-block-start: ${({ scrolled }) => (scrolled ? '64px' : '0px')};
  position: sticky;
  top: 10vh;
  overflow-y: auto;

  @media screen and (max-width: 1025px) {
    position: relative;
    top: 0;
    width: 100%;
    max-width: 100%;
    height: auto;
    border-right: none;
    padding: 0;
    padding-block-start: 0;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 568px) {
    display: none;
  }
`;

export const SidebarContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DealContent = styled.div`
  margin: 54px 0;

  #see-what-say,
  #our-customers,
  #our-team,
  #who-we-are,
  #shared-building-contents,
  #earthquake,
  #shared-building-structure,
  #employers-liability,
  #personal-claims-for-committee-members,
  #third-party-insurance {
    scroll-margin-top: 150px;
  }

  #listen-to-our-podcasts,
  #attachments,
  #comparison-of-terms-deductibles-and-prices,
  #price-quote,
  #electric-charging-station,
  #article-on-building-insurance,
  #bar-oz-insurance-center,
  #insurance-coverage-shared-building,
  #opening {
    scroll-margin-top: 120px;
  }

  .ant-spin-nested-loading {
    margin-block-end: 20px;
  }

  /**
   * Antd dims and blurs what it covers. The room is only being located, not
   * rebuilt, so it stays readable underneath — just clearly not ready yet.
   */
  .ant-spin-blur {
    opacity: 0.75;
    filter: none;
  }

  .ant-spin-nested-loading > div > .ant-spin {
    max-height: none;

    .ant-spin-text {
      padding-block-start: 8px;
      font-size: 15px;
      text-shadow: none;
    }
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    flex-direction: row-reverse;
    align-items: center !important;
    padding: 27px 24px;
    gap: 25px;
  }

  span.anticon.anticon-right.ant-collapse-arrow {
    transform: rotate(270deg) !important;
    vertical-align: middle;
    margin: 0 0 0 0 !important;
  }

  .ant-collapse-item.ant-collapse-item-active {
    span.anticon.anticon-right.ant-collapse-arrow {
      transform: rotate(180deg) !important;
    }
  }

  .ant-collapse > .ant-collapse-item {
    border: 1px solid #0000001a;
    background: #ffffff;
    border-radius: 8px;
  }

  span.ant-collapse-header-text {
    font-weight: ${FONT_WEIGHT.extremeBold};
    color: #1a295a;
    font-size: 22px;
    min-width: 0;
    overflow: hidden;
  }

  #deal-pdf iframe {
    background-color: white !important;
  }

  .child-container {
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
      padding: 12px 16px;
    }
  }

  .ant-collapse-item.ant-collapse-item-active {
    .ant-collapse-content {
      span.anticon.anticon-right.ant-collapse-arrow {
        transform: rotate(270deg) !important;
      }

      .ant-collapse-item.ant-collapse-item-active {
        span.anticon.anticon-right.ant-collapse-arrow {
          transform: rotate(180deg) !important;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    margin: 20px 0;

    span.ant-collapse-header-text {
      font-size: 20px;
    }

    .react-pdf__Document.dyno-document {
      max-width: 100%;

      canvas {
        max-width: 100%;
        height: auto !important;
        object-fit: contain;
      }
    }
  }
`;

export const ParentCollapse = styled(Collapse)`
  border: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: transparent;
`;

export const ChildContainer = styled.div`
  padding: 0 12px;

  @media screen and (max-width: 768px) {
    padding: 0 8px;
  }

  @media screen and (max-width: 640px) {
    padding: 0 4px;
  }
`;

export const ChildCollapse = styled(Collapse)`
  border: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: transparent;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  direction: rtl;
`;

export const FixedBtn = styled.button`
  position: fixed;
  top: auto;
  bottom: 100px;
  margin: auto;
  inset-inline: auto 72px;
  background: #ce6239;
  height: 48px;
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 9;
  &:hover {
    background: darken(#ce6239, 5%);
  }

  @media screen and (max-width: 768px) {
    inset-inline: auto 12px;
    bottom: 20px;
    font-size: 14px;
  }
`;

export const FixedLink = styled.a`
  position: fixed;
  top: auto;
  bottom: 112px;
  font-weight: ${FONT_WEIGHT.extraBold};
  background: white;
  margin: auto;
  inset-inline: auto 148px;
  color: #ce6239;
  border-bottom: 1px solid #ce6239;
  cursor: pointer;
  z-index: 9;

  &:hover {
    color: #ce6239;
  }

  @media screen and (max-width: 768px) {
    inset-inline: auto 90px;
    bottom: 32px;
    font-size: 14px;
  }
`;

export const PanelSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    cursor: pointer;
  }
`;

export const PanelHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
`;

export const PanelHeaderText = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  min-width: 0;
  flex: 1 1 0;
  overflow: hidden;
  max-width: 100%;
`;

export const PanelHeaderDescription = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 300;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-top: 2px;
`;

export const PanelHeaderIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #ce6239;
  img {
    width: 38px;
    height: 38px;
  }
`;

export const SaveButton = styled(Button)`
  margin-top: 10px;
`;

export const VideoWrapper = styled.iframe`
  width: 100%;
  min-height: 500px;
  border: none;
  margin: 8px;

  @media screen and (max-width: 768px) {
    min-height: 180px;
    margin: 0;
  }
`;

export const DynamicRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-weight: ${FONT_WEIGHT.regular};
`;

export const LandingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 340px);
  width: 100%;

  @media screen and (max-width: 768px) {
    height: (100vh - 400px);
  }
`;

export const LandingContent = styled.div`
  text-align: center;

  h1 {
    font-size: 2.5rem;
    font-weight: ${FONT_WEIGHT.extremeBold};
    color: #37352f;
    margin-bottom: 16px;

    max-width: 1024px;

    .no-break {
      white-space: nowrap;
    }

    @media screen and (max-width: 1025px) {
      font-size: 2.2rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.6rem;
    }
  }
`;

export const NoData = styled.p`
  font-size: 1.2rem;
  font-weight: ${FONT_WEIGHT.medium};
  color: #37352f;
  margin-bottom: 0;
`;
